module.exports = __webpack_public_path__ + "static/media/delos.bf963421.jpg";